import * as React from 'react';
import styled from 'styled-components';
import { IComparisonResult } from '../../../data/providers/reports/comparisonReportProvider';
import { Entity } from '../../../data/types';
import { Row } from '../../layout/Row';
import { EPdfMode } from '../../shared/pdf/Pdf';
import { ComparisonResult } from './ComparisonResult';

interface IProps {
  results: IComparisonResult[];
  colors: string[];
  pdfMode: EPdfMode;
  entity: Entity;
  comparisonEntityName: string;
}
export const ResultList = (props: IProps): React.ReactElement => {
  return (
    <Row>
      <Container>
        {props.results.map(
          (result: IComparisonResult, index: number): React.ReactElement => {
            return (
              <ComparisonResult
                result={result}
                key={index}
                colors={props.colors}
                pdfMode={props.pdfMode}
                entity={props.entity}
                comparisonEntityName={props.comparisonEntityName}
              />
            );
          }
        )}
      </Container>
    </Row>
  );
};

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-bottom: var(--grid-gap);
`;
